/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Setup_TitleInputs */

const en_mk_desktop_setup_title = /** @type {(inputs: Mk_Desktop_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps to connect`)
};

const id_mk_desktop_setup_title = /** @type {(inputs: Mk_Desktop_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga langkah untuk terhubung`)
};

/**
* | output |
* | --- |
* | "Three steps to connect" |
*
* @param {Mk_Desktop_Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_setup_title = /** @type {((inputs?: Mk_Desktop_Setup_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Setup_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_setup_title(inputs)
	return en_mk_desktop_setup_title(inputs)
});